/*
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2025-02-28 16:22:34
 * @LastEditors: zhaoyuanbang zhaoyuanbang@longfor.com
 * @LastEditTime: 2025-09-04 10:39:08
 * @FilePath: /qd-c4-yunjing-web/src/router/modules/home.ts
 * @Description: 这是默认设置,请设置`customMade`,
 */
import { RouteRecordRaw } from 'vue-router';
import Layout from '@/layouts/index.vue';

export const homeRoutes: RouteRecordRaw[] = [

  {
    path: '/home',
    name: 'home-root',
    component: Layout,
    meta: {
      authCodes: ['SMART_CENTER'],
    },
    children: [
      {
        path: '/home/index',
        name: 'home-index',
        component: () => import('@/views/dashboard/index.vue'),
        meta: {
          authCodes: ['SMART_CENTER'],
          title: '中枢',
          keepAlive: true,
          hideSelectProject: true,
        },
      }
    ],
  }
];
